import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {PulsatingDot} from '@Components/poster-editor/components/pulsating-dot';
import styles from './prompt-box-header.module.scss';
import type {HeaderContent} from '@Components/ai-resdesign-prompt-box/ai-redesign-prompt-box.types';

interface PromptBoxHeaderProps {
  headerContent: HeaderContent;
}

export function PromptBoxHeader({headerContent}: PromptBoxHeaderProps): ReactElement {
  const getPulsatingDot = (): ReactElement | undefined => {
    if (!headerContent.showPulsatingDot) {
      return;
    }

    return <PulsatingDot containerClassname={`_position-relative  ${styles.pulsatingDot}`} />;
  };

  const getIcon = (): ReactElement | null => {
    if (!headerContent.icon) {
      return null;
    }

    return <Icon icon={headerContent.icon} className={`content-ai`} size={IconSize.SIZE_ICON_16} />;
  };

  const getHeader = (): ReactElement => {
    return (
      <div className={'flexbox gap-1 flex-align-items-center spacing-m-b-1'}>
        <Text val={headerContent.title} className={`content-ai`} size={TextSize.XSMALL} bold />
        {getIcon()}
        {getPulsatingDot()}
      </div>
    );
  };

  return getHeader();
}
